import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';

export class DeleteSocialNetworkUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(id: string): Promise<void> {
    return this.repository.delete(id);
  }
}
